import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {DEFAULT_PAGE_INDEX, LiveResult, PAGE_SIZE_10, PagedFilter, Pages} from "@model";
import {LiveResultFilter} from "../model/live-result-filter";

export const LiveResultsResolver: ResolveFn<Observable<LiveResult | null> |
  Promise<LiveResult> | LiveResult> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService),
   router: Router = inject(Router)): Observable<LiveResult | null> |
    Promise<LiveResult> | LiveResult => {
    let currentPath: string | undefined = route.routeConfig?.path;
    let raceId: number | undefined = +route.queryParams['raceId'] ? +route.queryParams['raceId'] : undefined;
    let resultsFilter: LiveResultFilter = new LiveResultFilter();
    resultsFilter.raceId = raceId;
    if (!currentPath?.includes("fullscreen")) {
      resultsFilter.name = route.queryParams['name'] ? route.queryParams['name'] : undefined;
      resultsFilter.gender = route.queryParams['gender'] ? route.queryParams['gender'] : undefined;
    }
    if (raceId) {
      return liveResultsService.fetchLiveResults(
        new PagedFilter<LiveResultFilter>(new Pages(PAGE_SIZE_10, DEFAULT_PAGE_INDEX), resultsFilter), true)
        .pipe(
          take(1),
          mergeMap((res: LiveResult | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    }

  }
